import { defineComponent as n, openBlock as a, createBlock as r, unref as l, mergeProps as p, withCtx as c, createElementVNode as m } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconContact",
  __name: "IconContact",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (i, e) => (a(), r(l(v), p(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M20.25 14.5v-9a1.75 1.75 0 0 0-1.75-1.75h-13A1.75 1.75 0 0 0 3.75 5.5v9a1.75 1.75 0 0 0 1.75 1.75h1a1.25 1.25 0 0 1 1.25 1.25v1.94l3.645-2.916a1.25 1.25 0 0 1 .78-.274H18.5a1.75 1.75 0 0 0 1.75-1.75m1.5-9v9a3.25 3.25 0 0 1-3.25 3.25h-6.237L7.47 21.586A.75.75 0 0 1 6.25 21v-3.25H5.5a3.25 3.25 0 0 1-3.25-3.25v-9A3.25 3.25 0 0 1 5.5 2.25h13a3.25 3.25 0 0 1 3.25 3.25",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
